<template>
    <!-- Ablaufspalte des Lernmodus (Layoutskizze C): Fortschrittsbalken und
         alle Schritte untereinander. Die Anweisung selbst steht gross in der
         Mitte ueber dem Geraet (Funkgeraet.vue); hier sieht man, wo man im
         Ganzen steht. Nur zum Ansehen, angeklickt wird nichts. -->
    <div class="ablauf">
        <div class="balken" aria-hidden="true">
            <span :style="{ transform: `scaleX(${Math.min(index, schritte.length) / schritte.length})` }"></span>
        </div>
        <ol class="schritte">
            <li v-for="(s, i) in schritte" :key="i"
                :class="{ erledigt: i < index, aktiv: aktiv && i === index }"
                :aria-current="aktiv && i === index ? 'step' : null">
                <span class="marke" aria-hidden="true">{{ i < index ? '' : i + 1 }}</span>
                <span class="text">{{ s.label }}</span>
                <span class="nur-vorlesen">{{ i < index ? ', erledigt' : (aktiv && i === index ? ', jetzt' : '') }}</span>
            </li>
        </ol>
    </div>
</template>

<script>

export default {
    props: {
        // Alle Schritte der Anleitung (GuideSteps.js).
        schritte: Array,
        // Index des laufenden Schritts; gleich schritte.length = alle erledigt.
        index: Number,
        // Ob die Anleitung gerade laeuft.
        aktiv: Boolean
    }
}

</script>

<style scoped>
.balken {
    height: 6px;
    margin: 0 0 1rem;
    overflow: hidden;
    background: var(--zs-flaeche);
    border-radius: 3px;
}

/* Volle Breite, per scaleX auf den Anteil gestaucht: transform statt
   width, damit der Balken ohne Neuberechnung des Layouts waechst. */
.balken span {
    display: block;
    height: 100%;
    background: var(--zs-oliv);
    transform-origin: left center;
    transition: transform 0.3s ease-out;
}

.schritte {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    margin: 0;
    padding: 0;
    list-style: none;
}

.schritte li {
    display: flex;
    align-items: flex-start;
    gap: 0.7rem;
    padding: 0.5rem 0.6rem;
    font-size: 0.92rem;
    line-height: 1.4;
    color: var(--zs-grau);
    border: 1px solid transparent;
    border-radius: var(--zs-ecke);
}

.marke {
    display: grid;
    place-items: center;
    flex: none;
    width: 1.5rem;
    height: 1.5rem;
    font-size: 0.75rem;
    font-weight: 700;
    color: var(--zs-grau);
    border: 1.5px solid var(--zs-rahmen);
    border-radius: 50%;
    box-sizing: border-box;
}

.schritte li.erledigt {
    color: var(--zs-tinte);
}

.schritte li.erledigt .marke {
    color: #ffffff;
    background: var(--zs-oliv);
    border-color: var(--zs-oliv);
}

.schritte li.erledigt .marke::before {
    content: '\2713';
}

/* Der laufende Schritt: umrahmt und kraeftig, wie in der Skizze. */
.schritte li.aktiv {
    font-weight: 600;
    color: var(--zs-tinte);
    background: var(--zs-tafel);
    border-color: var(--zs-tinte);
}

.schritte li.aktiv .marke {
    color: #ffffff;
    background: var(--zs-tinte);
    border-color: var(--zs-tinte);
}

@media (prefers-reduced-motion: reduce) {
    .balken span {
        transition: none;
    }
}
</style>
